type ClientType = 'serverless' | 'browser';

export interface AnalyticsDefaultPayload {
  clientType: ClientType;
  releaseEnv: string;
  sessionID?: string;
  userAgent?: string;
  url?: string;
  title?: string;
  language?: string;
  referrer?: string;
  metadata?: { [key: string]: string | number } | null;
}

export interface AnalyticsSuppliedPayload {
  clientType?: ClientType;
  releaseEnv?: string;
  sessionID?: string;
  userAgent?: string;
  url?: string;
  title?: string;
  language?: string;
  referrer?: string;
  eventAction: string;
  eventCategory: string;
  eventLabel?: string;
  userID?: string | null;
  eventID?: string;
  eventMetadata?: { [key: string]: unknown } | null;
}

export interface IEvent {
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  eventMetadata?: { [key: string]: unknown } | null;
  time?: string;
}

export interface AnalyticsBatchPayload {
  clientType?: ClientType;
  releaseEnv?: string;
  sessionID?: string;
  userAgent?: string;
  url?: string;
  title?: string;
  language?: string;
  referrer?: string;
  userID?: string | null;
  eventID?: string;
  events: (IEvent & Pick<AnalyticsSuppliedPayload, 'userID'>)[];
  time?: string;
}

/**
 * Base64 encode a string.
 *
 * @param i
 */
const base64 = (i: string) => Buffer.from(i, 'utf8').toString('base64');

/**
 * Takes a type name and an ID specific to that type name, and returns a
 * "global ID" that is unique among all types.
 */
export const toGlobalId = (type: string, id: string) => base64([type, id].join(':'));
export const JERRY_ANALYTICS_INTERNAL_SOURCE = 'ja_intsrc';
